// src/components/PublicHeader.js
import React from 'react';
import { Link } from 'react-router-dom';
import '../styles.css';

function PublicHeader() {
  return (
    <header className="public-header">
      <div className="public-header-content">
        <Link to="/" className="public-logo">
          <img src="/logo.png" alt="Hot Setup" />
          <span>Hot Setup</span>
        </Link>
        <Link to="/login" className="btn btn-save" style={{ fontWeight: 'bold' }}>Login</Link>
      </div>
    </header>
  );
}

export default PublicHeader;